import React from 'react';
import WebsiteDemoViewer from './WebsiteDemoViewer';

function App() {
  return <WebsiteDemoViewer />;
}

export default App;
